import { Component, Input } from '@angular/core';
import { MbIcon } from '@am/moebius';

@Component({
    selector: 'combo-ticket',
    templateUrl: './combo-ticket.component.html',
    styleUrls: ['./combo-ticket.component.scss'],
    imports: [MbIcon]
})
export class ComboTicketComponent {
  @Input()
  public hasTickets: boolean;

  @Input()
  public hasMealPlan: boolean;

  @Input()
  public isFreeMealPlan: boolean;

  @Input()
  public optionalSupplements: boolean;

  constructor() {}
}
